import GoalDetails from "./GoalDetails"
export default GoalDetails
